
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Credits',
  
  created(){
    window.location.href = "/documents/CC_Privacyverklaring_&_Credits.pdf";
  }
});
